import React from 'react'

import { StyledRowDivider } from './SignatureListStyled'

const SignatureListRowDivider = () => <StyledRowDivider />

export default SignatureListRowDivider
